import React, { useContext, useState } from 'react'

import { ResourceWrapper, ObjectiveBox, Spinner, NoDataForList } from 'Components'
import { OBJECTIVE_KPI_VALUES } from 'Queries'
import { GlobalContext, checkLevel } from 'Utils'
import { objectivesMock } from 'Mockups/ObjectivesMock'

import { Alert, Spin } from 'antd'
import styled from '@emotion/styled'
import { useQuery } from '@apollo/client'
import { get } from 'lodash'
import moment from 'moment'

const checkFilters = (objective, kpi, { tipo, cuando, idMedida, empleado }) =>
  kpi &&
  (!tipo || tipo === kpi.distribucionValorRef.id) &&
  (!cuando || cuando === kpi.cuandoEvaluar.id) &&
  (!empleado ||
    objective.empleados
      .map(({ codEmpleado }) => codEmpleado)
      .includes(empleado)) &&
  (!idMedida || !idMedida.length || idMedida.includes(kpi.idMedida))

export const ObjectiveBoxQuery = ({
  objective,
  onCompleted: completed,
  filter,
  setLoading,
  navigate,
  kpisLoading,
  num,
  isPainted,
  setIsPainted,
  goNext,
  setGoNext
}) => {
  const context = useContext(GlobalContext)
  const isDev = context.isDev
  const codDistribuidor = get(context, 'currentUser.infoHesa') !== null ? get(context, 'currentUser.infoHesa.codDistribuidor') : (get(context, 'currentUser.codDistribuidor') || null)
  const profileId = get(context, 'currentUser.profile.id')
  const codEmpleado = get(context, 'currentUser.infoHesa') !== null ? get(context, 'currentUser.infoHesa.codEmpleado') : (get(context, 'currentUser.codEmpleado') || null)
  const isHesa = get(context, 'currentUser.infoHesa.isHesa') || false
  const nivelInfoHesa = checkLevel(get(context, 'currentUser.infoHesa.nivel'))
  const comercialView = (get(context, 'currentUser.profile.id') !== 'GE' && get(context, 'currentUser.profile.id') !== 'JV') ||
    (
      (get(context, 'currentUser.profile.id') === 'GE' && (
        ((filter.nivel && filter.nivel !== 'JV') && filter.empleado) &&
        (filter.empleado && filter.empleado !== get(context, 'currentUser.codEmpleado'))
      )) ||
      (get(context, 'currentUser.profile.id') === 'JV' && (
        (filter.empleado && filter.empleado !== get(context, 'currentUser.codEmpleado'))
      ))
    )

  const [numElem] = useState(num)
  const canCallKpis = codEmpleado !== null && (profileId !== undefined || isHesa)
  const [showText, setShowText] = useState(false)

  const variables = {
    id: {
      codDistribuidor,
      ano: objective.ano,
      codObjetivo: objective.codObjetivo,
    },
    codEmpleado: (isHesa && !filter.empleado) ? codEmpleado : filter.empleado ? filter.empleado : get(context, 'currentUser.codEmpleado'),
    nivel: (isHesa && !filter.empleado) ? nivelInfoHesa : filter.empleado ? filter.nivel : get(context, 'currentUser.profile.id'),
  }
  const kpiKey = `${objective.ano}-${objective.codObjetivo}`

  const onCompleted = ({ objetivoKpiValores }) => {
    setTimeout(() => {
      setShowText(true);
      setLoading(kpiKey, objetivoKpiValores);
      if (!isPainted) setIsPainted(true)
      if (!goNext) setGoNext(true)
      context.resetKeepAliveTimer();
    }, 175)
  }

  const objectiveKpi = isDev
    ? objectivesMock.data.objetivoKpiValores.find(
      ({ codObjetivo }) => codObjetivo === objective.codObjetivo,
    )
    : kpisLoading[kpiKey]

  const resource = useQuery(OBJECTIVE_KPI_VALUES, {
    fetchPolicy: 'network-only',
    variables,
    skip: !canCallKpis || (isDev || objectiveKpi),
    onCompleted,
  })

  if (objectiveKpi) {
    if (num === numElem) completed()
  }

  let month = null
  let currentTime = get(context, 'currentUser.currentTime')
  let day = moment(currentTime).date()

  const isKpiMensual = isDev || get(objectiveKpi, 'cuandoEvaluar.id') === 'M'
  if (isKpiMensual) {
    month =
      objective.estado === 'ACTIVO'
        ? day === 1
          ? moment(currentTime).month() || 12
          : moment(currentTime).month() + 1
        : (objectiveKpi && moment(objectiveKpi.fechaHasta).month() + 1) || 0
  }
  const isKpiComercial =
    isDev || get(objectiveKpi, 'distribucionValorRef.id') === 'C'

  if (!isDev) {
    if (resource.error) {
      setLoading(kpiKey, true)
      setTimeout(() => {
        setLoading(kpiKey, resource.error.message)
        setGoNext(true);
        // completed()
      }, 500)
    }
    if (resource.loading) {
      setLoading(kpiKey, false)
      return (
        <Inner borderColor="#ADADAD">
          <div style={{ background: "#f9faf9", position: 'absolute', top: -55, right: 35, padding: 5 }}>
            <Spin />
          </div>
          <Spinner />
        </Inner>
      )
    }
    if (typeof objectiveKpi === 'string') {
      const message = 'Se están procesando los datos. Recargue la página para verlos'
      return (
        <Inner
          borderColor="#ffe58f"
          onClick={() =>
            isKpiMensual
              ? onClickMensual(objective.codObjetivo, objective.ano, month)
              : onClickFinalPeriodo(objective.codObjetivo, objective.ano)
          }
        >
          <Alert message="Información" description={message} type="warning" showIcon />
        </Inner>
      )
    }
  }

  const showingData = typeof objectiveKpi === 'object';
  const filterOK = !showingData || checkFilters(objective, objectiveKpi, filter)
  if (!filterOK) return null

  const onClickFinalPeriodo = (codObjetivo, ano) => {
    navigate(`/dashboard/objectives/follow-up/reports/${codObjetivo}/${ano}`)
  }

  const onClickMensual = (codObjetivo, ano, month) => {
    navigate(
      filter.empleado && !isKpiComercial
        ? `/dashboard/objectives/follow-up/monthly/${codObjetivo}/${ano}`
        : `/dashboard/objectives/follow-up/reports/${codObjetivo}/${ano}${month ? '/' + month : ''
        }`,
    )
  }

  return (
    <ResourceWrapper resource={resource} noManage={isDev || showingData}>
      {(showingData && (
        <ObjectiveBox
          kpi={objectiveKpi}
          onClick={() =>
            isKpiMensual ? onClickMensual(objective.codObjetivo, objective.ano, month)
            : onClickFinalPeriodo(objective.codObjetivo, objective.ano)
          }
          isKpiComercial={isKpiComercial}
          isNotClickable={objectiveKpi.idMedida !== 'A' && (filter.empleado && !isKpiComercial && !isKpiMensual)}
          comercialView={comercialView}
          isHesa={isHesa}
        />
      )) || (
          <Inner borderColor="#ADADAD">
            {showText && <NoDataForList minHeight={175} text="No hay datos" />}
          </Inner>
        )}
    </ResourceWrapper>
  )
}

const Inner = styled.div`
  border-top: 4px solid ${props => props.borderColor};
  display: inline-block;
  width: 328px;
  height: 280px;
  margin: 0 25px 40px 25px;
  padding: 16px 20px;
  box-shadow: 0 4px 12px 0 rgba(200, 198, 198, 0.5);
  cursor: pointer;
`
